import { createContext, useContext } from "react";

export const LangContext = createContext("es");
export const useLang = () => useContext(LangContext);

const S = {
  es: {
    product_tag: "Fusion + Nowcast · M5",
    anomalies: "ANOMALÍAS",
    tick_crit: "CRIT",
    tick_warn: "CAUT",
    tick_ops: "OPER",
    scope_all: "Todo el territorio",
    // layer HUD
    layers_title: "Capas de datos soberanos",
    layer_gpm: "NASA GPM · Precipitación",
    layer_sentinel: "Sentinel-3 · Saturación suelo",
    layer_flood: "SNCZI · Inundación T=100",
    layer_roads: "IGN · Carreteras",
    layer_bridges: "IGN · Puentes/Pasos",
    layer_ports: "IGN · Puertos",
    layer_airstrips: "IGN · Aeródromos",
    live: "LIVE",
    sample: "SMPL",
    flood_ref: "REF",
    flood_ref_tip: "Servicio SNCZI no disponible — capa de referencia Q100 verificada",
    radar_label: "RADAR",
    radar_off: "OFF",
    radar_updated: "actualizado",
    radar_status_live: "AEMET OpenData · actualizado",
    radar_status_down: "Radar no disponible — AEMET y OPERA sin cobertura",
    radar_health_live: "Radar conectado",
    radar_health_down: "Radar no disponible (AEMET y EUMETNET OPERA)",
    sources_agree: "FUENTES COINCIDEN",
    tip_sources_agree: "AEMET y Open-Meteo coinciden en el pronóstico — confianza reforzada",
    layer_radar: "AEMET · Radar Nacional",
    layer_saih: "SAIH · Aforos de río",
    layer_ems: "Copernicus EMS · Activaciones",
    badge_saih: "SAIH VERDAD SOBRE EL TERRENO",
    badge_aemet: "AEMET CONFIRMADO",
    tip_aemet_confirmed: "Estación AEMET cercana confirma lluvia por encima del umbral; la escalada de severidad exige acuerdo Open-Meteo + AEMET",
    badge_ems: "COPERNICUS EMS CONFIRMADO",
    confidence: "Confianza",
    // alert feed
    feed_title: "Flujo de anomalías activas",
    tab_all: "TODO",
    tab_now: "AHORA",
    tab_forecast: "PRON.",
    tab_crit: "CRÍT",
    tab_warn: "CAUT",
    sev_critical: "CRÍTICO",
    sev_warning: "PRECAUCIÓN",
    sev_info: "OPERATIVO",
    sev_nodata: "SIN DATOS",
    sovereign_badge: "VERIFICACIÓN SOBERANA · SNCZI ≥70%",
    vs_base: "vs base",
    locate: "LOCALIZAR",
    no_anomalies: "Sin anomalías en esta categoría",
    tip_risk: "Índice de riesgo",
    tip_depth: "Calado estimado",
    tip_infra: "Infraestructura afectada",
    tip_variance: "Variación frente a la línea base climatológica histórica (NASA POWER)",
    tip_overlap: "Solape con zona inundable SNCZI (confianza)",
    // nowcast (M5)
    forecast_badge: "PRONÓSTICO",
    lead_label: "Antelación",
    eta_label: "ETA",
    tip_lead: "Tiempo de antelación hasta superar el umbral de alerta",
    proj_peak: "Intensidad pico proyectada (Open-Meteo + AEMET)",
    // reports (M5 PDF)
    nav_map: "MAPA",
    nav_reports: "INFORMES",
    download_pdf: "Descargar Informe PDF",
    reports_title: "Archivo de Informes",
    reports_subtitle: "Informes soberanos generados automáticamente · orden cronológico inverso",
    no_reports: "Aún no se han generado informes. Se crean automáticamente para alertas CRÍTICAS y de PRECAUCIÓN.",
    generated_label: "Generado",
    // DANA simulation (M6)
    dana_toggle: "SIMULACIÓN DANA",
    sim_badge: "SIMULACIÓN",
    dana_banner: "MODO SIMULACIÓN — Datos históricos DANA octubre 2024 — No es una emergencia activa.",
    dana_timeline: "Línea temporal del evento",
    dana_predicted: "Predicción RESILIO.ES",
    dana_real: "Impacto Real Documentado",
    dana_overlap: "Cobertura predicción/impacto EMSR773",
    dana_lead: "Primera alerta crítica",
    dana_aemet_peak: "Pico AEMET oficial 24 h",
    dana_inputs_note: "Solo se almacenan datos brutos históricos (lluvia horaria Open-Meteo ERA5 y modelo archivado, totales diarios oficiales AEMET OpenData 07-07 UTC desagregados por hora como estimación, lecturas SAIH documentadas evaluadas con los umbrales oficiales CHJ obtenidos de saih.chj.es). Severidad, confianza, fuentes y huella se calculan con las reglas del motor en vivo.",
    dana_report_btn: "Descargar Informe de Validación DANA",
    dana_nasa: "Corroboración NASA POWER (oct 2024)",
    dana_peak: "Pico",
    dana_total: "Acumulado",
    dana_nasa_na: "Corroboración NASA POWER no disponible",
    dana_variance: "Variación vs climatología NASA POWER (oct)",
    // live-map controls (uncertainty + playback)
    reset_view: "Restablecer vista (España)",
    time_playback: "Reproducción temporal",
    time_now: "Ahora",
    play: "Reproducir",
    pause: "Pausar",
    plume_legend: "Pluma de precipitación prevista",
    confidence_legend: "Halo = incertidumbre (menor confianza → mayor halo)",
    // ALIA
    alia_report: "INFORME ALIA",
    alia_report_hide: "OCULTAR INFORME ALIA",
    alia_report_header: "INFORME DE RIESGO · ALIA (IA SOBERANA)",
    drafting: "Redactando informe soberano…",
    alia_err_narrative: "No ha sido posible generar el informe ALIA en este momento.",
    console_header: "ALIA",
    console_sub: "ASISTENTE · INTELIGENCIA SOBERANA",
    analysing: "ALIA está analizando los datos en vivo…",
    ask_placeholder: "Pregunte a ALIA… p.ej. ¿Es seguro el puente B-302 esta noche?",
    alia_err_ask: "ALIA no está disponible en este instante. Inténtelo de nuevo.",
    chat_clear: "Reiniciar",
    chat_copy: "Copiar",
    chat_copied: "Copiado",
    chat_empty_hint: "Pregunte a ALIA sobre la situación en vivo. Ejemplos:",
    chat_starters: [
      "¿Dónde está la situación más crítica ahora mismo?",
      "¿Qué municipios requieren atención inmediata?",
      "Resuma el estado de las estaciones SAIH",
    ],
    login_headline: "Inteligencia antes del impacto.",
    login_sub: "RESILIO.ES fusiona datos espaciales soberanos — NASA GPM, Copernicus, AEMET y SNCZI — para anticipar inundaciones en los municipios de España, horas antes de que ocurran.",
    login_point1: "Detección temprana de anomalías pluviométricas sobre cada cuenca.",
    login_point2: "Verificación soberana con cartografía oficial SNCZI e IGN (EPSG:25830).",
    login_point3: "Informes y alertas redactados por ALIA, la IA soberana del Estado.",
    login_access: "Acceso de operador",
    login_access_sub: "Introduzca sus credenciales para acceder al panel de mando.",
    login_user: "Usuario",
    login_password: "Contraseña",
    login_submit: "Acceder al panel",
    login_signing: "Verificando…",
    login_err: "No se pudo iniciar sesión. Inténtelo de nuevo.",
    login_footer: "Uso oficial y exclusivo de autoridades competentes · RGPD UE 2016/679 · LOPDGDD 3/2018.",
    logout: "Salir",
    feed_footer: "MOTOR DE DETECCIÓN + NOWCAST · NASA GPM + OPEN-METEO + AEMET · ACT. CADA 2 MIN",
    // map
    coord_hint: "Mueva el cursor sobre el mapa",
    // GDPR
    gdpr_text:
      "RGPD UE 2016/679 · LOPDGDD 3/2018 — USO OFICIAL Y EXCLUSIVO DE AUTORIDADES COMPETENTES · DATOS TRATADOS CONFORME A NORMATIVA DE PROTECCIÓN DE DATOS",
    eu_hosted: "Datos alojados en la UE · RGPD",
    gdpr_sources: "FUENTES: MITECO SNCZI · IGN/SCNE · EPSG:25830 (ETRS89 UTM 30N)",
  },
  en: {
    product_tag: "Fusion + Nowcast · M5",
    anomalies: "ANOMALIES",
    tick_crit: "CRIT",
    tick_warn: "WARN",
    tick_ops: "OPS",
    scope_all: "Entire territory",
    layers_title: "Sovereign data layers",
    layer_gpm: "NASA GPM · Precipitation",
    layer_sentinel: "Sentinel-3 · Soil saturation",
    layer_flood: "SNCZI · Flood T=100",
    layer_roads: "IGN · Roads",
    layer_bridges: "IGN · Bridges/Crossings",
    layer_ports: "IGN · Ports",
    layer_airstrips: "IGN · Airfields",
    live: "LIVE",
    sample: "SMPL",
    flood_ref: "REF",
    flood_ref_tip: "SNCZI service unavailable — verified Q100 reference layer",
    radar_label: "RADAR",
    radar_off: "OFF",
    radar_updated: "updated",
    radar_status_live: "AEMET OpenData · updated",
    radar_status_down: "Radar unavailable — AEMET and OPERA not serving",
    radar_health_live: "Radar connected",
    radar_health_down: "Radar unavailable (AEMET and EUMETNET OPERA)",
    sources_agree: "SOURCES AGREE",
    tip_sources_agree: "AEMET and Open-Meteo agree on the forecast — confidence boosted",
    layer_radar: "AEMET · National Radar",
    layer_saih: "SAIH · River gauges",
    layer_ems: "Copernicus EMS · Activations",
    badge_saih: "SAIH GROUND TRUTH",
    badge_aemet: "AEMET CONFIRMED",
    tip_aemet_confirmed: "A nearby AEMET station confirms rainfall above threshold; severity escalates only when Open-Meteo and AEMET agree",
    badge_ems: "COPERNICUS EMS CONFIRMED",
    confidence: "Confidence",
    feed_title: "Active anomaly feed",
    tab_all: "ALL",
    tab_now: "NOW",
    tab_forecast: "FCST",
    tab_crit: "CRIT",
    tab_warn: "WARN",
    sev_critical: "CRITICAL",
    sev_warning: "WARNING",
    sev_info: "OPERATIONAL",
    sev_nodata: "NO DATA",
    sovereign_badge: "SOVEREIGN VERIFICATION · SNCZI ≥70%",
    vs_base: "vs base",
    locate: "LOCATE",
    no_anomalies: "No anomalies in this category",
    tip_risk: "Risk index",
    tip_depth: "Estimated water depth",
    tip_infra: "Affected infrastructure",
    tip_variance: "Variance against the NASA POWER historical climatological baseline",
    tip_overlap: "Overlap with SNCZI flood zone (confidence)",
    // nowcast (M5)
    forecast_badge: "FORECAST",
    lead_label: "Lead time",
    eta_label: "ETA",
    tip_lead: "Lead time until the alert threshold is crossed",
    proj_peak: "Projected peak intensity (Open-Meteo + AEMET)",
    // reports (M5 PDF)
    nav_map: "MAP",
    nav_reports: "REPORTS",
    download_pdf: "Download PDF Report",
    reports_title: "Report Archive",
    reports_subtitle: "Automatically generated sovereign reports · reverse chronological order",
    no_reports: "No reports generated yet. They are created automatically for CRITICAL and WARNING alerts.",
    generated_label: "Generated",
    // DANA simulation (M6)
    dana_toggle: "DANA SIMULATION",
    sim_badge: "SIMULATION",
    dana_banner: "SIMULATION MODE — Historical DANA data October 2024 — Not an active emergency.",
    dana_timeline: "Event timeline",
    dana_predicted: "RESILIO.ES Prediction",
    dana_real: "Documented Real Impact",
    dana_overlap: "Prediction/EMSR773 impact coverage",
    dana_lead: "First critical alert",
    dana_aemet_peak: "Official AEMET 24 h peak",
    dana_inputs_note: "Only raw historical inputs are stored (Open-Meteo ERA5 and archived-model hourly rain, official AEMET OpenData 07-07 UTC daily totals split into hourly estimates, documented SAIH readings scored against official CHJ thresholds pulled from saih.chj.es). Severity, confidence, sources and footprint are computed with the live engine's rules.",
    dana_report_btn: "Download DANA Validation Report",
    dana_nasa: "NASA POWER corroboration (Oct 2024)",
    dana_peak: "Peak",
    dana_total: "Accumulated",
    dana_nasa_na: "NASA POWER corroboration unavailable",
    dana_variance: "Variance vs NASA POWER climatology (Oct)",
    // live-map controls (uncertainty + playback)
    reset_view: "Reset view (Spain)",
    time_playback: "Temporal playback",
    time_now: "Now",
    play: "Play",
    pause: "Pause",
    plume_legend: "Predicted precipitation plume",
    confidence_legend: "Halo = uncertainty (lower confidence → larger halo)",
    alia_report: "ALIA REPORT",
    alia_report_hide: "HIDE ALIA REPORT",
    alia_report_header: "RISK REPORT · ALIA (SOVEREIGN AI)",
    drafting: "Drafting sovereign report…",
    alia_err_narrative: "The ALIA report could not be generated at this time.",
    console_header: "ALIA",
    console_sub: "ASSISTANT · SOVEREIGN INTELLIGENCE",
    analysing: "ALIA is analysing the live data…",
    ask_placeholder: "Ask ALIA… e.g. Is bridge B-302 safe tonight?",
    alia_err_ask: "ALIA is unavailable right now. Please try again.",
    chat_clear: "Reset",
    chat_copy: "Copy",
    chat_copied: "Copied",
    chat_empty_hint: "Ask ALIA about the live situation. Examples:",
    chat_starters: [
      "Where is the most critical situation right now?",
      "Which municipalities need immediate attention?",
      "Summarise the status of the SAIH gauges",
    ],
    login_headline: "Intelligence before impact.",
    login_sub: "RESILIO.ES fuses sovereign space data — NASA GPM, Copernicus, AEMET and SNCZI — to anticipate floods across Spain's municipalities, hours before they strike.",
    login_point1: "Early detection of rainfall anomalies over every river basin.",
    login_point2: "Sovereign verification against official SNCZI & IGN cartography (EPSG:25830).",
    login_point3: "Reports and alerts authored by ALIA, the State's sovereign AI.",
    login_access: "Operator access",
    login_access_sub: "Enter your credentials to reach the command dashboard.",
    login_user: "Username",
    login_password: "Password",
    login_submit: "Enter dashboard",
    login_signing: "Verifying…",
    login_err: "Could not sign in. Please try again.",
    login_footer: "Official use by competent authorities only · GDPR EU 2016/679 · LOPDGDD 3/2018.",
    logout: "Sign out",
    feed_footer: "DETECTION + NOWCAST ENGINE · NASA GPM + OPEN-METEO + AEMET · REFRESH EVERY 2 MIN",
    coord_hint: "Move the cursor over the map",
    gdpr_text:
      "GDPR EU 2016/679 · Spanish Data Protection Act 3/2018 — OFFICIAL USE BY COMPETENT AUTHORITIES ONLY · DATA PROCESSED IN COMPLIANCE WITH DATA PROTECTION LAW",
    eu_hosted: "Data hosted in the EU · GDPR",
    gdpr_sources: "SOURCES: MITECO SNCZI · IGN/SCNE · EPSG:25830 (ETRS89 UTM 30N)",
  },
};

export const tLang = (l) => S[l] || S.es;
export const useT = () => tLang(useLang());

export function timeAgo(iso, lang) {
  const diff = (Date.now() - new Date(iso).getTime()) / 60000;
  const n = diff < 60 ? Math.max(1, Math.round(diff)) : Math.round(diff / 60);
  const unit = diff < 60 ? "min" : "h";
  return lang === "en" ? `${n} ${unit} ago` : `hace ${n} ${unit}`;
}
